var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.996 6.998h18.008M9.569 11H6.998m2 6.002h-3a3.001 3.001 0 01-3.002-3.001V5.998a3.001 3.001 0 013.001-3.002h12.005a3.001 3.001 0 013.002 3.002v4.001m-3.5 7.326v-1.754m.001 3.439V19m-2.59 2.418l-1.328-1.329A2.001 2.001 0 0113 18.675V16.33c0-.53.21-1.04.586-1.415l1.328-1.328A1.998 1.998 0 0116.33 13h2.344c.53 0 1.04.21 1.414.586l1.33 1.33a2 2 0 01.586 1.414v2.343c0 .53-.21 1.04-.586 1.414l-1.33 1.33a1.998 1.998 0 01-1.414.586H16.33c-.53 0-1.04-.21-1.415-.586z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCardWarning;